angular.module("Main").filter("einheit", function () {
    return function (source, count) {
        if (_.isNaN(source))
            return "";

        if ((source === "ww" || source === "w") && count > 1)
            return "T_Einheit_Wochen";
        if ((source === "ww" || source === "w") && count === 1)
            return "T_Einheit_Woche";
        if (source === "d" && count > 1)
            return "T_Einheit_Tage";
        if (source === "d" && count === 1)
            return "T_Einheit_Tag";
        if (source === "m" && count > 1)
        return "T_Einheit_Monate";
        if (source === "m" && count === 1)
        return "T_Einheit_Monat";
        if (source === "y" && count > 1)
            return "T_Einheit_Jahre";
        if (source === "y" && count === 1)
            return "T_Einheit_Jahr";
    }
});